module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BM-Head-bmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_195",
      "title": "195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-No-Indent-bmtx1"
  }, [_vm._v("Thank you Mark McCoy, Dee Hodson, David Hodson, Libby Burton, Lauren Cerand, Sarah Manguso, Kevin Sampsell, Monika Woods.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-bmtx"
  }, [_vm._v("Thank you Marina Abramovi"), _c('span', {
    staticClass: "bm-text-bmtx-_span-accent-characters-acc"
  }, [_vm._v("ć")]), _vm._v(", Jo Ann Beard, Sven Birkerts, Molly Lindley Pisani, Ron Carlson, Megan Carter, Kerry Cullen, Ruth Curry, Asher Dark, Libby Flores, Christopher Frizzelle, Laura Childs Gill, Emily Gould, Dinah Lenney, Maggie Nelson, Jeff Shotts, Lauren Smythe, Shelly Taylor, Peter Trachtenberg, Eric Tran, Steven Trull, and the PEN Center USA Emerging Voices Fellowship.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 66
// module chunks = 0